import paths from '~/app/paths/paths';
import MenuConstants from '~/constants/menu-constants';

type GreenkeeperNavigationMenuId =
  | MenuConstants.GREENKEEPER_HOME
  | MenuConstants.GREENKEEPER_TASKS
  | MenuConstants.GREENKEEPER_FAIRWAYS
  | MenuConstants.GREENKEEPER_LOG_ACTIVITIES;

export interface GreenkeeperNavigationItem {
  icon: string;
  id: GreenkeeperNavigationMenuId;
  isOnlyActiveWhenMatchingAll?: boolean;
  isSidebarActiveDisabled?: boolean;
  labelKey: string;
  menuLinkId: string;
  path: string;
}

const greenkeeperNavigationMenuIds: readonly GreenkeeperNavigationMenuId[] = [
  MenuConstants.GREENKEEPER_HOME,
  MenuConstants.GREENKEEPER_TASKS,
  MenuConstants.GREENKEEPER_FAIRWAYS,
  MenuConstants.GREENKEEPER_LOG_ACTIVITIES,
];

export const greenkeeperMobileSubmenu = greenkeeperNavigationMenuIds.map((id) => ({ id }));

const greenkeeperNavigationItemsById: Record<
  GreenkeeperNavigationMenuId,
  GreenkeeperNavigationItem
> = {
  [MenuConstants.GREENKEEPER_HOME]: {
    id: MenuConstants.GREENKEEPER_HOME,
    icon: 'action.home',
    labelKey: 'navigation.home',
    menuLinkId: 'greenkeeperHomeMenuLink',
    path: paths.greenkeeperRoot.path,
    isOnlyActiveWhenMatchingAll: true,
  },
  [MenuConstants.GREENKEEPER_FAIRWAYS]: {
    id: MenuConstants.GREENKEEPER_FAIRWAYS,
    icon: 'action.layer',
    isSidebarActiveDisabled: true,
    labelKey: 'navigation.fairways',
    menuLinkId: 'greenkeeperFairwaysMenuLink',
    path: paths.greenkeeperFairways.path,
  },
  [MenuConstants.GREENKEEPER_TASKS]: {
    id: MenuConstants.GREENKEEPER_TASKS,
    icon: 'action.check',
    labelKey: 'navigation.tasks',
    menuLinkId: 'greenkeeperTasksMenuLink',
    path: paths.greenkeeperTasks.path,
  },
  [MenuConstants.GREENKEEPER_LOG_ACTIVITIES]: {
    id: MenuConstants.GREENKEEPER_LOG_ACTIVITIES,
    icon: 'other.list',
    labelKey: 'navigation.log_activities',
    menuLinkId: 'greenkeeperLogActivitiesMenuLink',
    path: paths.greenkeeperLogActivities.path,
  },
};

export const greenkeeperNavigationItems: readonly GreenkeeperNavigationItem[] =
  greenkeeperNavigationMenuIds.map((id) => greenkeeperNavigationItemsById[id]);

export const getGreenkeeperNavigationItem = (id: MenuConstants) => {
  switch (id) {
    case MenuConstants.GREENKEEPER_HOME:
    case MenuConstants.GREENKEEPER_TASKS:
    case MenuConstants.GREENKEEPER_FAIRWAYS:
    case MenuConstants.GREENKEEPER_LOG_ACTIVITIES:
      return greenkeeperNavigationItemsById[id];

    default:
      return undefined;
  }
};
